import React, {useEffect, useState} from 'react';
import RenderHtml from 'react-native-render-html';
import {useInnerStyle} from './promotion.hooks';
import DetailNavTitle from '@businessComponents/detail-nav-title';
import {goBack} from '@utils';
import {PromotionListItem, getPromotionDetail} from './promotion.service';
import {ScrollView, View} from 'react-native'; //Image
import theme from '@/style';
// import Text from '@basicComponents/text';
// import Button from '@basicComponents/button';
import {useTranslation} from 'react-i18next';
// import {goToUrl} from '@/common-pages/game-navigate';
import {LazyImageLGBackground} from '@/components/basic/image';
import {useRoute} from '@react-navigation/native';
import {BasicObject} from '@/types';
// import {useSettingWindowDimensions} from '@/store/useSettingStore';

const PromotionDetail = () => {
  const {i18n} = useTranslation();
  const {id} = useRoute().params as BasicObject;
  const [item, setItem] = useState<PromotionListItem>();
  const {
    // size: {screenHeight, screenWidth, designWidth},
    size: {screenHeight, screenWidth},
    // itemStyle,
    // listStyle,
    // detailStyle,
  } = useInnerStyle();
  // const {calculateItemWidth} = useSettingWindowDimensions();
  // const imageWidth = screenWidth - theme.paddingSize.l * 2;

  const getPromotionDetails = async () => {
    try {
      const res = await getPromotionDetail(id as number);
      setItem(res);
    } catch (error) {}
  };

  useEffect(() => {
    getPromotionDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const source = {
    html: item?.activityContent || '',
  };
  const htmlStyle = {
    fontSize: theme.fontSize.m,
    lineHeight: theme.fontSize.m * 1.4,
    fontFamily: 'Inter',
    color: '#000000',
  };
  const tagsStyles = {
    p: {
      marginTop: 0,
      marginBottom: 0,
    },
    img: {
      // width: screenWidth - (theme.paddingSize.xxl + theme.paddingSize.l) * 2,
      width: screenWidth,
    },
  };

  return (
    <LazyImageLGBackground style={[{height: screenHeight}]}>
      <DetailNavTitle
        title={i18n.t('promotion.title')}
        hideAmount
        hideServer
        onBack={goBack}
      />
      <ScrollView style={[theme.flex.flex1, theme.background.white]}>
        {/* <Image
          style={[
            {
              width: screenWidth,
              height: calculateItemWidth(120),
            },
          ]}
          source={{uri: item?.activityIcon}}
        /> */}
        {/* <Text
          fontSize={20}
          fontWeight="700"
          style={[
            {
              color: '#000000',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: 20,
            },
          ]}>
          {item?.activityTitle}
        </Text> */}
        <View style={[theme.background.white]}>
          <RenderHtml
            source={source}
            baseStyle={htmlStyle}
            tagsStyles={tagsStyles}
          />
        </View>
      </ScrollView>
    </LazyImageLGBackground>
  );
};

export default PromotionDetail;
